import Dexie from 'dexie';

export const db = new Dexie('PunchLog');

db.version(1).stores({
  timeEntries:     'id, workplace_id, date, schedule_id, cost_code',
  workplaces:      'id, workplace_name, pay_structure',
  schedules:       'id, workplace_id, effective_date, is_override',
  scheduledShifts: 'id, date, workplace_id, source',
  signedBundles:   'bundle_id, client_id, created_at',
  invoices:        '++id, client_name, generated_at, month_key',
  billingProfiles: '++id, name, is_default',
  pendingUploads:  '++id, bundle_id, created_at',
});
